import Marquee from "react-fast-marquee";
import { STACK } from "@/data/content";

export default function StackMarquee() {
  return (
    <section data-testid="stack-marquee" className="relative py-16 border-y border-white/5 bg-slate-950/60">
      <div className="mx-auto max-w-7xl px-6 md:px-10 mb-6 flex items-center gap-4">
        <div className="eyebrow">/ Trusted stack we ship in production</div>
        <div className="flex-1 divider-gradient" />
      </div>
      <Marquee speed={40} gradient gradientColor="#020617" gradientWidth={120} pauseOnHover>
        {STACK.map((s) => (
          <div
            key={s}
            className="mx-6 md:mx-10 font-display text-2xl md:text-3xl font-semibold text-slate-400/80 hover:text-cyan-300 transition-colors tracking-tight whitespace-nowrap"
          >
            {s}
          </div>
        ))}
      </Marquee>
    </section>
  );
}
